import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './LimitsEmpty.styles';

export const LimitsEmpty = () => {
  const { t } = useTranslation();

  return (
    <S.Box>
      <img
        src="/limits-empty.png"
        alt=""
        width={255}
        height={191}
        loading="lazy"
      />
      <S.Title $variant="3">
        {t('pages.cabinet.you_dont_have_any_placements_yet')}
      </S.Title>
      <S.Subtitle $variant="1">
        {t('pages.cabinet.here_will_be_displayed_limits')}
      </S.Subtitle>
    </S.Box>
  );
};
